import { Box } from '@mui/material';
import { FC } from 'react';
import { DeliveryInspectionStage, DeliveryStatus } from 'api/models/Deliveries';
import { Set } from 'api/models/Sets';
import theme from 'App.theme';
import DeliverySetButton from 'components/SetList/components/DeliverySetButton';
import { useLanguage } from 'context/AppContext';

type Props = {
  stage: DeliveryInspectionStage;
  deliveryStatus: DeliveryStatus;
  consolidatedSet: Set;
  memberSets: Set[];
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  onUngroup?: () => void;
  ungroupLoading?: boolean;
};

// a consolidated set with the sets grouped under it; shared so every screen shows groups the same way
const ConsolidatedSetGroup: FC<Props> = ({
  stage,
  deliveryStatus,
  consolidatedSet,
  memberSets,
  selected,
  disabled,
  onClick,
  onUngroup,
  ungroupLoading,
}) => {
  const lang = useLanguage()[0].ConsolidatedSetGroup;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.layout.spacing.small,
        padding: theme.layout.spacing.small,
        border: `1px solid ${theme.colors.purple}`,
        borderRadius: 1,
        backgroundColor: theme.colors.transPurple,
      }}
    >
      <DeliverySetButton
        stage={stage}
        deliveryStatus={deliveryStatus}
        set={consolidatedSet}
        selected={selected}
        disabled={disabled}
        onClick={onClick}
        onUngroup={onUngroup}
        ungroupLoading={ungroupLoading}
      />

      {!!memberSets.length && (
        <>
          <Box
            sx={{
              color: theme.colors.purple,
              fontSize: 12,
              fontWeight: 500,
              textTransform: 'uppercase',
              paddingLeft: theme.layout.spacing.medium,
            }}
          >
            {lang.setsOnThisTray({ count: memberSets.length })}
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: theme.layout.spacing.small,
              marginLeft: theme.layout.spacing.medium,
              paddingLeft: theme.layout.spacing.small,
              borderLeft: `2px solid ${theme.colors.purple}`,
            }}
          >
            {memberSets.map(member => (
              <DeliverySetButton
                key={member.kitInstanceId}
                stage={stage}
                deliveryStatus={deliveryStatus}
                set={member}
                selected
              />
            ))}
          </Box>
        </>
      )}
    </Box>
  );
};

export default ConsolidatedSetGroup;
